import { render, staticRenderFns } from "./wdmpyy.vue?vue&type=template&id=7d568840&scoped=true&"
import script from "./wdmpyy.vue?vue&type=script&lang=js&"
export * from "./wdmpyy.vue?vue&type=script&lang=js&"
import style0 from "./wdmpyy.vue?vue&type=style&index=0&id=7d568840&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d568840",
  null
  
)

export default component.exports